import { Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NotificationsService } from '@services/notifications.service';

const ICONE: Record<string, string> = {
  success: 'check_circle',
  error: 'error',
  warn: 'warning',
  info: 'info',
};

@Component({
  standalone: true,
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  imports: [MatButtonModule, MatIconModule, MatSnackBarModule],
})
export class SnackBarComponent {
  readonly notificationsService = inject(NotificationsService);

  readonly header = computed(() => this.notificationsService.snackBarMessage().content.header);
  readonly content = computed(() => this.notificationsService.snackBarMessage().content.body);
  readonly type = computed(() => this.notificationsService.snackBarMessage().content.type);

  /**
   * Le icone erano `<use xlink:href="/assets/icons/sprites.svg#it-check-circle">`,
   * cioe' lo sprite di bootstrap-italia. Ora arrivano dal set Material, che il
   * pannello serve gia' da solo.
   */
  readonly icona = computed(() => ICONE[this.type()] ?? 'info');
}
